import { faCheck, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import { IListarComprovantesUsuarioResponse } from "../../../../../Interfaces/Vendas/Usuario/UsuarioInterface";
import moment from "moment";
import { ConcluirAtividadeVendasController } from "../../../../../Controllers/Vendas/Caso/CasoController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import VerAtendimento from "../../../../../Components/CardsPages/Atendimento/VerAtendimento";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";

interface IAgendaAtividadeDetalhes {
    compromissos: IListarComprovantesUsuarioResponse;
    updateList?: any;
}

export default function AgendaAtividadeDetalhes({
    compromissos,
    updateList,
}: IAgendaAtividadeDetalhes) {
    const isTimeString =
        typeof compromissos.DT_DURACAO === "string" &&
        compromissos.DT_DURACAO.match(/^\d{2}:\d{2}:\d{2}$/);

    const formattedTime = isTimeString
        ? compromissos.DT_DURACAO.slice(0, 5)
        : moment(compromissos.DT_DURACAO).format("HH:mm");

    const isTimeStringDtCasoAtividade =
        typeof compromissos.DT_CASO_ATIVIDADE === "string" &&
        compromissos.DT_CASO_ATIVIDADE.match(/^\d{2}:\d{2}:\d{2}$/);

    const formattedTimeDtCasoAtividade = isTimeStringDtCasoAtividade
        ? compromissos.DT_CASO_ATIVIDADE.slice(0, 5)
        : moment(compromissos.DT_CASO_ATIVIDADE).format("DD/MM/YYYY");

    const { id } = useModuloInfo();

    const {
        execute: ConcluirAtividadeVendas,
        loading: ConcluirAtividadeVendasLoading,
    } = useAsyncCallback(ConcluirAtividadeVendasController);

    return (
        <div>
            <div className="w-100 d-flex align-items-center justify-content-between font-weight-bolder font-size-h4">
                <span className="d-flex justify-content-center align-items-center">
                    {formattedTimeDtCasoAtividade} {formattedTime} -{" "}
                    {compromissos.DS_TIPO_ATIVIDADE}
                </span>
                <div className="d-flex flex-row-reverse">
                    <VerAtendimento
                        ID_CASO={compromissos.ID_CASO}
                        ID_TIPO_CASO={id ?? 0}
                    />
                </div>
            </div>

            <hr />
            {compromissos.FL_CONCLUIDO && (
                <div className="d-flex flex-row g-2 align-items-center">
                    <span className="rounded-circle bg-light-success text-success p-2 d-inline-flex align-items-center justify-content-center mr-2 my-1">
                        <FontAwesomeIcon icon={faCheck} />
                    </span>
                    <span>Atividade executada</span>
                </div>
            )}

            <div className="d-flex flex-row g-2 align-items-center">
                <span className="rounded-circle bg-light-info text-info p-2 d-inline-flex align-items-center justify-content-center mr-2 my-1">
                    <FontAwesomeIcon icon={faUser} />
                </span>
                <span>{compromissos.DS_NOME_CLIENTE}</span>
            </div>

            <div>
                <span className="font-weight-bolder">Descrição</span>
                <p className="bg-light rounded p-2">
                    {/* {compromissos.DS_DESCRICAO} */}teste
                </p>
            </div>

            {!compromissos.FL_CONCLUIDO && (
                <div className="d-flex justify-content-end align-items-center">
                    <button
                        className="btn btn-success"
                        onClick={() => {
                            Swal.fire({
                                title: `Deseja concluir essa atividade?`,
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    ConcluirAtividadeVendas([
                                        {
                                            ID_ATIVIDADE:
                                                compromissos.ID_ATIVIDADE,
                                            ID_CASO: compromissos.ID_CASO,
                                        },
                                    ]).then(() => {
                                        if (updateList) updateList();
                                    });
                                }
                            });
                        }}
                    >
                        {ConcluirAtividadeVendasLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faCheck} />
                        )}{" "}
                        Marcar como concluído
                    </button>
                </div>
            )}
        </div>
    );
}
